/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902706710 — Error404Screen */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../../../shared/ui/AnimatedIcon/animations/cross.json';
import { usePageTracking } from '../../../../shared/hooks/usePageTracking';
import styles from './Error404Screen.module.css';

interface ErrorScreenProps {
    title?: string;
}

export const Error404Screen = (props: ErrorScreenProps) => {
    const { title } = props;
    const { t } = useTranslation();

    usePageTracking(title || 'Error 404');

    useEffect(() => {
        console.error('Error 404. URL:' + window.location.href);
    }, []);

    return (
        <ScreenWrapper>
            <ScreenTitle>
                {t(title || 'Ooops. Error 404. No such page')}
            </ScreenTitle>
            <ContentBox>
                <AnimatedIcon
                    animationData={crossAnimation}
                    loop={false}
                    className={styles.animationWrapper}
                />
            </ContentBox>
        </ScreenWrapper>
    );
};
